import { BaseService } from './baseService';

class ContactImportsService extends BaseService<
	ContactImport,
	'contactImportID',
	'contactImports'
> {
	constructor() {
		super('contactImportID', 'contactImport', 'contactImports');
	}
}

export default new ContactImportsService();
